// ---------------------------------------------------------------
// IMPORTS
// ---------------------------------------------------------------
import { log, errorlog } from '../logger/logger';

// json
import i18n from './i18n.json';

// ---------------------------------------------------------------
// DEFAULTS
// ---------------------------------------------------------------

// ---------------------------------------------------------------
// CLASS
// ---------------------------------------------------------------
export class I18n {

    constructor() {}

    init() {
        log('i18n init');
    }

    getCurrentJson() {
        return getCurrentJson();
    }

    getLang() {
        return getCurrentLang();
    }
}

// ---------------------------------------------------------------
// PRIVATE FUNCTIONS
// ---------------------------------------------------------------
function getCurrentJson() {
    return i18n[getCurrentLang()];
}

// UTIL
// ---------------------------------------------------------------
function getCurrentLang() {
    let currentLang = window.navigator.language || window.navigator.userLanguage;
    currentLang = currentLang.split('-'); // if "de-CH" or similar --> use only "de"
    currentLang = currentLang[0];

    if(currentLang !== 'de') {
        currentLang = 'en';
    }

    return currentLang;
}